import { FC } from 'react';
import { useWatch } from 'antd/lib/form/Form';
import Item from 'antd/lib/form/FormItem';
import { FormInstance } from 'antd/lib/form/hooks/useForm';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import InputNumber from 'antd/lib/input-number';
import Switch from 'antd/lib/switch';

import MessageWrapper from 'components/MessageWrapper/MessageWrapper';
import QuestionMark from 'components/QuestionMark/QuestionMark';
import { selectPolicySettings } from 'store/selectors/settingsSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { formRules, questionMarks } from 'utils/constants/constants';
import { EPoliciesFields } from 'types/settings/enums';
import { ErrorIcn, InfoIcn } from 'utils/icons';

const TradingPoliciesMAP: FC<FormInstance> = (form) => {
  const { mapPercent, isMapPercent } = useTypedSelector(selectPolicySettings);
  const isMapSwitchTouched = useWatch(EPoliciesFields.IsMapPercent, form);
  const isMapInputTouched = useWatch(EPoliciesFields.MapPercent, form);

  return (
    <Row gutter={[20, 20]}>
      <Col span={12} className="mb-8">
        <h4 className="mb-4">Default Minimum Advertising Price (MAP)</h4>
        <div className="flex items-center gap-x-5">
          <Item name={EPoliciesFields.IsMapPercent} valuePropName="checked">
            <Switch />
          </Item>
          <div className="flex items-center mb-6">
            Apply Default Minimum Advertising Price (MAP)
            <QuestionMark>{questionMarks.tradingPolicy.map}</QuestionMark>
          </div>
        </div>
        <Item shouldUpdate noStyle>
          {({ getFieldValue }) => getFieldValue(EPoliciesFields.IsMapPercent) && (
            <div className="flex items-center gap-2.5 mb-2.5">
              <Item name={EPoliciesFields.MapPercent} className="mb-0" rules={[formRules.required]}>
                <InputNumber size="large" min={0} max={99} maxLength={2} className="w-16" placeholder="0" />
              </Item>
              <div className="flex items-center gap-2.5">
                <InfoIcn className="w-5 h-5 min-w-[20px]" />
                Enter an uplift % that will be added to all your new products’ cost (dropshipper&apos;s buying price)
                by default. The dropshippers won&apos;t be able to sell under the MAP.
              </div>
            </div>)}
        </Item>
        <MessageWrapper
          className="text-orange-50 bg-orange-50/20 gap-2"
          isVisible={mapPercent && (mapPercent !== isMapInputTouched)
            || isMapPercent && (isMapPercent !== isMapSwitchTouched)}
        >
          <ErrorIcn className="min-w-[20px]" />
          After changing the default MAP setting, it won&apos;t be applied to already uploaded products.
          You can change it manually on the My Products page.
        </MessageWrapper>
      </Col>
    </Row>
  );
};

export default TradingPoliciesMAP;
